import type { CityConfig } from "../city-template/types";

export const dearbornHeightsConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Wayne County Clerk", href: "https://www.waynecounty.com/elected/clerk/", description: "Wayne County Clerk — marriage license issuance" },
    { label: "Divorce Records — Wayne County Clerk", href: "https://www.waynecounty.com/elected/clerk/", description: "Wayne County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Dearborn Heights",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "dearborn-heights",
  route: "/cities/dearborn-heights",
  title: "Emergency Passport Dearborn Heights, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Dearborn Heights, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Dearborn Heights, Redford, Garden City, Inkster, and western Wayne County residents. Detroit Passport Agency alternative. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Dearborn Heights, MI",
  heroSubtitle: "Dearborn Heights and western Wayne County travelers trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. Located between Dearborn and the western suburbs, our courier service connects you directly to the Detroit Passport Agency without the downtown drive or appointment wait. A+ BBB rated serving all of Dearborn Heights and surrounding communities.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Suburban%20residential%20neighborhood%20in%20Dearborn%20Heights%20Michigan%20with%20mid-century%20brick%20ranch%20homes%2C%20mature%20trees%20with%20green%20lawns%2C%20quiet%20cul-de-sac%20street%2C%20warm%20golden%20afternoon%20light%2C%20American%20suburban%20atmosphere%2C%20well-maintained%20sidewalks%2C%20autumn%20foliage%2C%20no%20text%20no%20people%2C%20realistic%20photography%20style%2C%20warm%20earth%20tones%2C%20peaceful%20family%20neighborhood%20environment&width=1800&height=700&seq=dearborn-heights-hero-001&orientation=landscape",
  heroImageAlt: "Dearborn Heights Michigan suburban neighborhood with mid-century homes and warm afternoon light",
  geoPosition: "42.3369;-83.2733",
  geoPlacename: "Dearborn Heights, Michigan",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 15 miles east of Dearborn Heights — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Dearborn Heights", zips: "48125, 48127" },
    { name: "Dearborn", zips: "48120, 48121, 48123, 48124, 48125, 48126, 48128" },
    { name: "Redford", zips: "48239, 48240" },
    { name: "Garden City", zips: "48135, 48136" },
    { name: "Inkster", zips: "48141" },
    { name: "Westland", zips: "48185, 48186" },
    { name: "Taylor", zips: "48180" },
    { name: "Livonia", zips: "48150, 48151, 48152, 48153, 48154" },
    { name: "Canton", zips: "48187, 48188" },
    { name: "Wayne", zips: "48184" },
    { name: "Romulus", zips: "48174" },
    { name: "Lincoln Park", zips: "48146" },
    { name: "Allen Park", zips: "48101" },
    { name: "Melvindale", zips: "48122" },
    { name: "Southgate", zips: "48195" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-community-line", title: "Diverse Community", desc: "Experienced serving Dearborn Heights' multicultural families and international travelers" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any UPS or FedEx in Dearborn Heights or nearby" },
  ],
  internalLinks: [
    { name: "Expedited passport in Dearborn, MI", route: "/cities/dearborn" },
    { name: "Emergency passport services in Detroit, MI", route: "/cities/detroit" },
    { name: "Urgent passport services in Westland, MI", route: "/cities/westland" },
    { name: "Michigan passport services overview", route: "/states/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Dearborn Heights, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Dearborn Heights residents can ship from the UPS Store on Ford Road or any FedEx location in the western metro area.",
  fpcOfficeDistance: "Serving Dearborn Heights, Dearborn, Redford, Garden City, Inkster, Westland, Taylor, Livonia, and all of western Wayne County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Dearborn Heights and the western Detroit metro area. From the Ford Road corridor to the Michigan Avenue communities, from the Inkster Road neighborhoods to the border with Dearborn — we serve all of western Wayne County. Our courier service eliminates the need to drive downtown and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Dearborn Heights and all western Wayne County communities including Dearborn, Redford, Garden City, Inkster, Westland, Taylor, Livonia, Canton, Wayne, Romulus, Lincoln Park, Allen Park, Melvindale, and Southgate. We also serve travelers departing from Detroit Metro Airport (DTW) who need emergency passports.",
  howItWorksIntro: "Most Dearborn Heights travelers complete everything online and ship documents overnight. No waiting weeks for a passport agency appointment — our registered couriers handle the Detroit Passport Agency submission for you.",
  mistakesIntro: "Dearborn Heights residents often discover passport issues just before international travel. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Dearborn Heights and western Wayne County travelers — from healthcare workers to educators to families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Dearborn Heights, MI? Here are the most common ones we hear from western Wayne County travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for business and family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person downtown Detroit", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Dearborn Heights travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute flights, family emergencies, and business travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "Ideal for DTW departures and all international travel"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Dearborn Heights adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Dearborn Heights-area address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Dearborn Heights residents and families — including new citizens, young professionals, and families in the western Wayne County communities.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Dearborn Heights residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Dearborn Heights-area families planning international vacations or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Dearborn Heights and western Wayne County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Dearborn Heights MI", description: "Urgent passport processing for Dearborn Heights Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Dearborn Heights MI", description: "Fast passport renewal for Dearborn Heights Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Dearborn Heights MI", description: "New passport application services for Dearborn Heights Michigan residents applying for their first passport." },
    { name: "Child Passport Dearborn Heights MI", description: "Minor passport services for Dearborn Heights Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Amina K.",
      location: "Dearborn Heights, MI",
      rating: 5,
      text: "Family trip to Lebanon in 5 days and my husband's passport was expired. Fast Passport Center handled the renewal in 3 days. We shipped from the post office on Ford Road and everything went perfectly. Our kids got to meet their grandparents for the first time.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Michael S.",
      location: "Redford, MI",
      rating: 5,
      text: "Business trip to Germany in 4 days. I live in Redford and work near Dearborn Heights. No time to drive downtown for an agency appointment. Fast Passport Center got it done in 2 days. Professional and fast.",
      service: "Passport Renewal",
    },
    {
      name: "Nadia F.",
      location: "Dearborn Heights, MI",
      rating: 5,
      text: "First-time passports for my parents who are visiting family in Jordan. They were nervous about the process but Fast Passport Center walked us through every step. Done in 7 days. The agents were so patient and kind.",
      service: "First-Time Passports",
    },
    {
      name: "James L.",
      location: "Garden City, MI",
      rating: 5,
      text: "Lost my passport during a home renovation 2 days before my flight to Cancun. I was absolutely panicking. Fast Passport Center had a replacement in my hands in 36 hours. I made my flight and the resort. Cannot recommend enough.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "dearborn-heights-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "230 S Dearborn St, Suite 380",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 15 miles east of Dearborn Heights — downtown Detroit",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "dearborn-heights-2",
      name: "Dearborn Heights Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "26200 Michigan Ave",
      city: "Dearborn Heights",
      state: "MI",
      zip: "48127",
      phone: "(313) 563-0310",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Dearborn Heights — on Michigan Avenue",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Dearborn Heights acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient for Dearborn Heights, Redford, and Garden City residents.",
      icon: "ri-mail-line",
    },
    {
      id: "dearborn-heights-3",
      name: "Dearborn Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "19660 Ford Rd",
      city: "Dearborn",
      state: "MI",
      zip: "48128",
      phone: "(313) 943-4311",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Dearborn — approximately 3 miles east of Dearborn Heights",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular with Dearborn Heights residents near the Dearborn border. Ample parking. Serves Dearborn Heights, Dearborn, and surrounding communities.",
      icon: "ri-mail-line",
    },
    {
      id: "dearborn-heights-4",
      name: "Redford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "12245 Beech Daly Rd",
      city: "Redford",
      state: "MI",
      zip: "48239",
      phone: "(313) 533-3310",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Redford — approximately 4 miles north of Dearborn Heights",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Redford, Garden City, and northern Dearborn Heights residents. Book early — high demand during summer travel season.",
      icon: "ri-mail-line",
    },
    {
      id: "dearborn-heights-5",
      name: "Garden City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "31000 Maplewood St",
      city: "Garden City",
      state: "MI",
      zip: "48135",
      phone: "(734) 421-7800",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Garden City — approximately 4 miles west of Dearborn Heights",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Garden City, Westland, and western Dearborn Heights communities. Convenient location with ample parking.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in Dearborn Heights" },
    { feature: "Family Travel Expertise", agency: "No tailored advice", fpc: "Yes — we help with child passports and family bundles" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Dearborn Heights residents often discover passport issues just before their international trip. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for Air Travel",
      description: "Many western Wayne County travelers use a passport card or enhanced license for Canada driving trips — but these are not valid for international flights. If you fly from DTW, you need a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Dearborn Heights-area acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport Parental Consent Issues",
      description: "Child passport applications require both parents' consent. If one parent cannot appear, Form DS-3053 is required with a notarized signature. Many Dearborn Heights families are caught off guard by this requirement.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Dearborn Heights or western Wayne County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Dearborn Heights, Dearborn, or Livonia." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Dearborn Heights-area address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Dearborn Heights, MI?", a: "Fast Passport Center offers emergency passport processing in Dearborn Heights, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to take a day off work or drive downtown." },
    { q: "Where is the closest passport acceptance facility to Dearborn Heights?", a: "The Dearborn Heights Post Office at 26200 Michigan Ave is the primary local acceptance facility. The Dearborn Post Office on Ford Road, the Redford Post Office on Beech Daly, and the Garden City Post Office on Maplewood are also convenient options. All require appointments — book 1–2 weeks in advance." },
    { q: "Do I need to go to the Detroit Passport Agency myself?", a: "No. Fast Passport Center's registered couriers go to the Detroit Passport Agency for you. You simply complete your application online and ship your documents. Our couriers handle the rest — no downtown drive, no parking, no appointment wait." },
    { q: "Can I get a passport quickly for my whole family?", a: "Yes. Fast Passport Center specializes in family passport bundles. We can process multiple applications simultaneously — renewals, first-time passports, and child passports — all with the same fast turnaround. Perfect for Dearborn Heights families planning international travel together." },
    { q: "What airports do Dearborn Heights-area travelers use?", a: "Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international departure hub — approximately 15 minutes from Dearborn Heights. DTW offers direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and dozens of other destinations. Windsor Airport (YQG) is a secondary option for Canada travel." },
    { q: "How much does an expedited passport cost in Dearborn Heights, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Dearborn Heights residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Dearborn Heights and western Wayne County offer passport photos. The UPS Store on Ford Road and FedEx Office locations also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve all of western Wayne County?", a: "Yes. Fast Passport Center serves all of western Wayne County including Dearborn Heights, Dearborn, Redford, Garden City, Inkster, Westland, Taylor, Livonia, Canton, Wayne, Romulus, and all surrounding communities. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
  ],
  photoLocations: [
    { name: "Walgreens — Dearborn Heights", address: "26200 Ford Rd, Dearborn Heights, MI 48127", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Dearborn Heights", address: "26500 Ford Rd, Dearborn Heights, MI 48127", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/photo" },
    { name: "UPS Store — Dearborn Heights", address: "26200 Ford Rd, Dearborn Heights, MI 48127", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "FedEx Office — Dearborn", address: "22201 Michigan Ave, Dearborn, MI 48124", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com/default/office" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Dearborn Heights", address: "25637 Michigan Ave, Dearborn Heights, MI 48125", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Dearborn", address: "3200 Greenfield Rd, Dearborn, MI 48120", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Dearborn and eastern Dearborn Heights communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "15–20 minutes from Dearborn Heights via I-94 or Michigan Avenue",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for Metro Detroit. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Largest airport in Michigan.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
    {
      code: "YQG",
      name: "Windsor Airport (Canada)",
      distance: "25–30 minutes from Dearborn Heights via I-94 and Ambassador Bridge",
      address: "3200 County Rd 42, Windsor, ON N9A 6J3, Canada",
      note: "Secondary option for Dearborn Heights travelers crossing to Canada first. Smaller airport with limited international routes. Requires passport for air travel to/from Canada.",
      flightUrl: "https://www.yqg.ca/",
      flightLabel: "Windsor Airport Info",
      featured: false,
    },
  ],
};